import React from "react";
import Table from 'react-bootstrap/Table'

const style = {
    "fontFamily":"Open Sans Hebrew", 
    textAlign: "right",
    alignSelf: "stretch",
    lineHeight: 1
}

class TimeTable extends React.Component{
    constructor(props) {
        super(props);
    } 

    render() {
        return (
            <div style={style}>
                <Table>
                    <tbody>
                        <tr>
                            <td> <font size="3"> א </font> </td>
                            <td> &nbsp;&nbsp; </td>
                            <td> <font size="3"> {this.props.attributes["work_on_sunday"]["end_time"]} </font> </td>
                            <td> &nbsp;-&nbsp; </td>
                            <td> <font size="3"> {this.props.attributes["work_on_sunday"]["start_time"]} </font> </td>
                        </tr>
                        <tr>
                            <td> <font size="3"> ב </font> </td>
                            <td> &nbsp;&nbsp; </td>
                            <td> <font size="3"> {this.props.attributes["work_on_monday"]["end_time"]} </font> </td>
                            <td> &nbsp;-&nbsp; </td>
                            <td> <font size="3"> {this.props.attributes["work_on_monday"]["start_time"]} </font> </td>
                        </tr>
                        <tr>
                            <td> <font size="3"> ג </font> </td>
                            <td> &nbsp;&nbsp; </td>
                            <td> <font size="3"> {this.props.attributes["work_on_tuesday"]["end_time"]} </font> </td>
                            <td> &nbsp;-&nbsp; </td>
                            <td> <font size="3"> {this.props.attributes["work_on_tuesday"]["start_time"]} </font> </td>
                        </tr>
                        <tr>
                            <td> <font size="3"> ד </font> </td>
                            <td> &nbsp;&nbsp; </td>
                            <td> <font size="3"> {this.props.attributes["work_on_wednesday"]["end_time"]} </font> </td>
                            <td> &nbsp;-&nbsp; </td>
                            <td> <font size="3"> {this.props.attributes["work_on_wednesday"]["start_time"]} </font> </td>
                        </tr>
                        <tr>
                            <td> <font size="3"> ה </font> </td>
                            <td> &nbsp;&nbsp; </td>
                            <td> <font size="3"> {this.props.attributes["work_on_thursday"]["end_time"]} </font> </td>
                            <td> &nbsp;-&nbsp; </td>
                            <td> <font size="3"> {this.props.attributes["work_on_thursday"]["start_time"]} </font> </td>
                        </tr>
                        <tr>
                            <td> <font size="3"> ו </font> </td>
                            <td> &nbsp;&nbsp; </td>
                            <td> <font size="3"> {this.props.attributes["work_on_friday"]["end_time"]} </font> </td>
                            <td> &nbsp;-&nbsp; </td>
                            <td> <font size="3"> {this.props.attributes["work_on_friday"]["start_time"]} </font> </td>
                        </tr>
                        <tr>
                            <td> <font size="3"> ש </font> </td>
                            <td> &nbsp;&nbsp; </td>
                            <td> <font size="3"> {this.props.attributes["work_on_saturday"]["end_time"]} </font> </td>
                            <td> &nbsp;-&nbsp; </td>
                            <td> <font size="3"> {this.props.attributes["work_on_saturday"]["start_time"]} </font> </td>
                        </tr>
                    </tbody>
                </Table>
            </div>          
        );
    }
}

export default TimeTable;